<div class="now-decorative-card now-decorative-card-small ps-4">
  <h3>1. Schritt: Wählen Sie das Ziel Ihrer Weiterbildung</h3>
  <div>
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="now-radio-button-card themenfelder-card d-flex h-100">
          <input
            type="radio"
            name="radio-button-group"
            [id]="'bildungsbereich_' + Bildungsbereich.Erweitern"
            (change)="selectBildungsbereich(Bildungsbereich.Erweitern)"
          />
          <label
            [for]="'bildungsbereich_' + Bildungsbereich.Erweitern"
            class="now-radio-button-card-default now-card"
          >
            <span>Ich möchte mein Wissen erweitern.</span>
          </label>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="now-radio-button-card themenfelder-card d-flex h-100">
          <input
            type="radio"
            name="radio-button-group"
            [id]="'bildungsbereich_' + Bildungsbereich.Erwerb"
            (change)="selectBildungsbereich(Bildungsbereich.Erwerb)"
          />
          <label
            [for]="'bildungsbereich_' + Bildungsbereich.Erwerb"
            class="now-radio-button-card-default now-card"
          >
            <span>Ich möchte einen neuen Abschluss erwerben.</span>
          </label>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'd-flex flex-row-reverse justify-content-between': !isMobile() }">
      <button
        [disabled]="!selectedBildungsbereich"
        (click)="emitSelection()"
        type="button"
        class="now-btn now-btn-primary"
      >
        Weiter
      </button>
    </div>
  </div>
</div>
